import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

const ImageSlider = ({ images = [] }) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (images.length <= 1) return;
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 4500);
    return () => clearInterval(timer);
  }, [images.length]);

  if (!images || images.length === 0) return null;

  const current = images[index];

  return (
    <div className="px-6 pt-6" data-testid="home-image-slider">
      <div className="relative h-48 rounded-3xl overflow-hidden shadow-lg border border-stone-100">
        <AnimatePresence mode="wait">
          <motion.div
            key={current.id || index}
            initial={{ opacity: 0, scale: 1.05 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.6 }}
            className="absolute inset-0 bg-cover bg-center"
            style={{ backgroundImage: `url('${current.image_url}')` }}
          >
            <div className="absolute inset-0 bg-gradient-to-t from-emerald-950/80 via-emerald-900/20 to-transparent" />
            {(current.title || current.subtitle) && (
              <div className="absolute bottom-0 left-0 right-0 p-5">
                {current.title && (
                  <h3 className="text-white text-xl font-heading font-bold drop-shadow">
                    {current.title}
                  </h3>
                )}
                {current.subtitle && (
                  <p className="text-white/85 text-sm font-body mt-1 drop-shadow">
                    {current.subtitle}
                  </p>
                )}
              </div>
            )}
          </motion.div>
        </AnimatePresence>

        {images.length > 1 && (
          <div className="absolute bottom-3 right-4 flex gap-1.5 z-10">
            {images.map((img, i) => (
              <button
                key={img.id || i}
                data-testid={`slider-dot-${i}`}
                onClick={() => setIndex(i)}
                className={`h-2 rounded-full transition-all ${
                  i === index ? 'w-6 bg-[#D4AF37]' : 'w-2 bg-white/60'
                }`}
                aria-label={`Slide ${i + 1}`}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageSlider;
